import { render, staticRenderFns } from "./TipsFetch.vue?vue&type=template&id=948708b4&scoped=true&"
import script from "./TipsFetch.vue?vue&type=script&lang=js&"
export * from "./TipsFetch.vue?vue&type=script&lang=js&"
import style0 from "./TipsFetch.vue?vue&type=style&index=0&id=948708b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948708b4",
  null
  
)

export default component.exports